export default __webpack_public_path__ + "static/media/1109.7f38ec43.png";